import "./animations";
import "../../css/app.css";

import Main from "./main";
import { animationManager } from "./animations/animationManager";

document.addEventListener("DOMContentLoaded", function () {
	new Main();
	animationManager.initializeAnimations();
});
